import { StackProps, useCheckboxGroup, Flex } from '@chakra-ui/react';
import { FC, useEffect } from 'react';
import { AudioTypeOption } from 'types/audio';
import { CheckboxButton } from 'app/components/Core/CheckboxButton/CheckboxButton';

export interface AudioFilterBarProps extends StackProps {
  buttonGroupOptions?: AudioTypeOption[];
  defaultValues?: (string | number)[];
  onFilterChange: (value: (string | number)[]) => void;
}

export const AudioFilterBar: FC<AudioFilterBarProps> = ({
  buttonGroupOptions,
  defaultValues,
  onFilterChange,
  children,
  ...rest
}) => {
  const { value, getCheckboxProps, setValue } = useCheckboxGroup({
    defaultValue: defaultValues,
  });

  useEffect(() => {
    if (defaultValues) {
      setValue(defaultValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  useEffect(() => {
    onFilterChange(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <Flex flexDirection="row" m="0 auto" gap={3} w="full" {...rest}>
      {children}
      {buttonGroupOptions &&
        buttonGroupOptions.map((option) => (
          <CheckboxButton
            key={option.key}
            buttonTitle={option.name}
            {...getCheckboxProps({ value: option.key })}
          />
        ))}
    </Flex>
  );
};
